import { Entity, Scheduler } from "@dinahmoe/dmafjs-core";

class EventDispatch extends Entity {
  namespace = "control:event:dispatch";

  init(node) {
    node.pendingDispatch = new Scheduler(this, this.dispatchEvent.bind(this));
    node.hasDispatched = false;
  }

  execute(node, config, event) {
    node.props = config;

    if (node.props["dispatch.mode"] === "ONCE" && node.hasDispatched) {
      //this could cause problems with dynamic out event names
      this.log(
        "ONCE: out event",
        node.props["event.name"],
        "has already been dispatched"
      );
      return;
    }

    if (node.props["dispatch.clearPending"]) {
      node.pendingDispatch.clear();
    }

    let eventTime = event.time + node.props["dispatch.delay"];
    node.pendingDispatch.schedule(eventTime, node, {
      name: node.props["event.name"],
      time: eventTime,
      data: {
        ...event.data,
        ...node.props["event.data"],
      },
    });
  }

  dispatchEvent(node, event) {
    this.log("dispatching", event.name, event.time);
    this.dispatch(event.name, event.time, event.data);
    node.hasDispatched = true;
  }

  clear(node) {
    node.pendingDispatch.clear();
  }
}

const eventDispatch = new EventDispatch();

export { eventDispatch, EventDispatch };
